import { captureException, captureMessage, init } from '@sentry/react'

/**
 * Also decides which third-party environment the build pairs with (Airwallex's
 * fingerprint script must match the Airwallex the API talks to).
 */
export function getSentryEnvironment(): string {
  if (import.meta.env.VITE_SENTRY_ENVIRONMENT) {
    return import.meta.env.VITE_SENTRY_ENVIRONMENT
  }

  if (import.meta.env.MODE === 'production') {
    return 'production'
  } else {
    return 'development'
  }
}

init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  tracesSampleRate: 0.5,
  environment: getSentryEnvironment(),
})

export default { captureException, captureMessage }
